import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-booking-report',
  templateUrl: './booking-report.component.html',
  styleUrls: ['./booking-report.component.css']
})
export class BookingReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
